import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import GoogleTagManager from "./components/GoogleTagManager";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import ArticleEditor from "./pages/ArticleEditor";
import WorkspaceSettings from "./pages/WorkspaceSettings";
import ProfileSettings from "./pages/ProfileSettings";
import PricingPage from "./pages/PricingPage";
import AboutUsPage from "./pages/AboutUsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import ToolsHub from "./pages/ToolsHub";
import CharacterCountTool from "./pages/CharacterCountTool";
import WordCountTool from "./pages/WordCountTool";
import CaseConverterTool from "./pages/CaseConverterTool";
import RemoveSpacesTool from "./pages/RemoveSpacesTool";
import AiSeoContentBriefGenerator from "./pages/AiSeoContentBriefGenerator";
import BlogHub from "./pages/BlogHub";
import BlogPost from "./pages/BlogPost";
import ProtectedRoute from "./components/ProtectedRoute";
import "./App.css";

function TrailingSlashRedirect() {
  const location = useLocation();
  if (location.pathname.length > 1 && !location.pathname.endsWith('/')) {
    return <Navigate to={`${location.pathname}/${location.search}${location.hash}`} replace />;
  }
  return null;
}

function AppRouter() {
  return (
    <Routes>
      {/* Website (public, indexable) */}
      <Route path="/" element={<Landing />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/about" element={<AboutUsPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/terms-and-conditions" element={<TermsPage />} />
      <Route path="/tools" element={<ToolsHub />} />
      <Route path="/tools/character-count-online" element={<CharacterCountTool />} />
      <Route path="/tools/word-count-online" element={<WordCountTool />} />
      <Route path="/tools/case-converter-online" element={<CaseConverterTool />} />
      <Route path="/tools/remove-extra-spaces-online" element={<RemoveSpacesTool />} />
      <Route path="/tools/ai-seo-content-brief-generator" element={<AiSeoContentBriefGenerator />} />
      
      {/* Blog (public, indexable) */}
      <Route path="/blog" element={<BlogHub />} />
      <Route path="/blog/:slug" element={<BlogPost />} />

      {/* App (public but noindex) */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/auth/callback" element={<AuthCallback />} />

      {/* App (protected, noindex enforced by ProtectedRoute) */}
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/article/:articleId" element={<ProtectedRoute><ArticleEditor /></ProtectedRoute>} />
      <Route path="/workspace/:workspaceId/settings" element={<ProtectedRoute><WorkspaceSettings /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><ProfileSettings /></ProtectedRoute>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <GoogleTagManager />
      <TrailingSlashRedirect />
      <AppRouter />
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;
